import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.6645 5.84747L12.0003 0.845215L3.33759 5.84666L11.9995 10.8458L20.6645 5.84747ZM13.001 3.93V7.93H11.001V3.93H13.001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.6606 7.58178L12.9993 12.5779V22.5779L21.6606 17.5773V7.58178ZM16.0256 13.169L19.4897 15.169L18.4897 16.901L15.0256 14.901L16.0256 13.169Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.9993 22.5767V12.5778L2.34009 7.58015V17.5773L10.9993 22.5767ZM8.97618 14.901L5.51207 16.901L4.51207 15.169L7.97618 13.169L8.97618 14.901Z"}}]};

const Chart3DFilled = Vue.extend<IconProps>({
  name: 'Chart3DFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-3d-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Chart3DFilled;
